import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';

export function createPDF() {
  return new jsPDF();
}

export function addTable(doc, options) {
  autoTable(doc, options);
  return doc;
}

export { autoTable };
